import React from 'react'
import { makeStyles } from 'tss-react/mui'
import ResponsivePagination from '@src/components/ResponsivePagination'
import { sendNavigationInteractionEvent } from '@src/utils/analytics'

const useStyles = makeStyles()((theme) => ({
  responsivePaginationWrapper: {
    padding: theme.spacing(6, 0),
  },
}))

interface Props {
  numPages: number
  currentPage: number
  handleUpdatePage: (page: number) => void
  customPadding?: string
  customCounterStyling?: string
  customButtonStyling?: string
}

const Pagination: React.FC<Props> = ({
  currentPage,
  handleUpdatePage,
  numPages,
  customPadding,
  customCounterStyling,
  customButtonStyling,
}) => {
  const { classes } = useStyles()
  return (
    <div
      className={
        customPadding ? customPadding : classes.responsivePaginationWrapper
      }
      data-testid="search-results-pagination"
    >
      <ResponsivePagination
        currentPage={currentPage}
        handleUpdatePage={(page) => {
          sendNavigationInteractionEvent({
            action: 'pagination click',
            detail: `${page > currentPage ? 'next' : 'previous'} - page ${page} of ${numPages}`,
            component: 'body',
            elementType: 'button',
          })
          handleUpdatePage(page)
        }}
        numPages={numPages}
        customCounterStyling={customCounterStyling}
        customButtonStyling={customButtonStyling}
      />
    </div>
  )
}

export default Pagination
